import { v4 as uuid } from 'uuid';
import { forkJoin, mergeMap, of } from "rxjs";
import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import * as FlatModels from '@medsurf/flat-models';
import * as FlatActions from '@medsurf/flat-actions';
import * as FlatStates from '@medsurf/flat-states';
import * as FlatFacades from '../../internal';

@Injectable()
export class QuestionEntityFacade {
  constructor(protected store: Store) {
  }

  //<editor-fold desc="Selectors">

  //</editor-fold>

  //<editor-fold desc="Requests">
  
  static addSingleChoiceQuestion(store: Store,
                                 id: string,
                                 page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training) {
    // Create New Choices
    const newChoice1: FlatModels.ChoiceEntityModels.Choice = {
      id: uuid(),
      label: '',
      value: null,
      order: 0,
      question: id,
    };
    const newChoice2: FlatModels.ChoiceEntityModels.Choice = {
      id: uuid(),
      label: '',
      value: null,
      order: 1,
      question: id,
    };
    const newChoice3: FlatModels.ChoiceEntityModels.Choice = {
      id: uuid(),
      label: '',
      value: null,
      order: 2,
      question: id,
    };
    const newChoice4: FlatModels.ChoiceEntityModels.Choice = {
      id: uuid(),
      label: '',
      value: null,
      order: 3,
      question: id,
    };
    const newChoice5: FlatModels.ChoiceEntityModels.Choice = {
      id: uuid(),
      label: '',
      value: null,
      order: 4,
      question: id,
    };
    
    // Create New Single Choice Question
    const newSingleChoiceQuestion: FlatModels.QuestionEntityModels.SingleChoiceQuestion = {
      id,
      order: page.questions?.length || 0,
      choices: [uuid(), uuid(), uuid(), uuid(), uuid()],
      content: 'Neue Frage',
      placeholder: null,
      explanation: 'Erklärung',
      required: false,
      randomised: false,
      customEnumeration: null,
      numberingType: FlatModels.QuestionEntityModels.NumberingType.LETTER,
      type: FlatModels.QuestionEntityModels.QuestionType.enum.SingleChoiceQuestion,
      solution: null,
      slide: page.id,
    };
    
    // Update Page
    page.questions.push(newSingleChoiceQuestion.id);
    
    /* TODO this below (create questionPipeModel)
    // Add Choices And Question And Update Page
    return store.dispatch(new FlatActions.ChoiceEntityActions.AddEntity(newChoice1)).pipe(
      mergeMap(() =>
        store.dispatch(new FlatActions.ChoiceEntityActions.AddEntity(newChoice2))
      ),
      mergeMap(() =>
        store.dispatch(new FlatActions.ChoiceEntityActions.AddEntity(newChoice3))
      ),
      mergeMap(() =>
        store.dispatch(new FlatActions.ChoiceEntityActions.AddEntity(newChoice4))
      ),
      mergeMap(() =>
        store.dispatch(new FlatActions.ChoiceEntityActions.AddEntity(newChoice5))
      ),
      mergeMap(() =>
        store.dispatch(new FlatActions.QuestionEntityActions.AddEntity(newSingleChoiceQuestion))
      ),
      mergeMap(() =>
        store.dispatch(new FlatActions.PageEntityActions.UpdateEntity(page))
      ),
      mergeMap(() =>
        store.dispatch(new FlatActions.QuestionEntityActions.SetQuestionId(newSingleChoiceQuestion.id))
      ),
      mergeMap(() =>
        store.dispatch(new FlatActions.SlideAuthorActions.SetEditPanelDisplay(FlatModels.SlideAuthorModels.EditPanelDisplay.enum.question))
      ),
      mergeMap(() =>
        store.dispatch(new FlatActions.HistoryControlActions.FinishSnapshot(
          'history.question_add_single_choice',
          store.selectSnapshot(FlatStates.NavigationControlState.currentUrl$)
        ))
      ),
    );
    */
  }
  
  static addLongListQuestion(store: Store,
                             page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training) {
    // TODO
  }
  
  static addMappingQuestion(store: Store,
                            page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training) {
    // TODO
  }
  
  static addKPrimeQuestion(store: Store,
                           page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training) {
    // TODO
  }
  
  static addTrueFalseQuestion(store: Store,
                              page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training) {
    // TODO
  }
  
  static addFreeTextQuestion(store: Store,
                             page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training) {
    // TODO
  }
  
  static addIndicationQuestion(store: Store,
                               page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training) {
    // TODO
  }
  
  static addMultipleChoiceQuestion(store: Store,
                                   page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training) {
    // TODO
  }
  
  protected static copyQuestion(store: Store,
                                id: string,
                                page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training,
                                clusterParentUpdate = false) {
    // Get Data
    const typedQuestions = store.selectSnapshot(FlatStates.QuestionEntityState.typedEntities$);
    
    // Get Question
    const question = structuredClone(typedQuestions[id]);
    
    // Update Question
    question.id = uuid();
    question.slide = page.id;
    question.order = page.questions.length || 0;
    
    // Update Page
    page.questions.push(question.id);
    
    // Copy Question
    return of(question.id).pipe(
      mergeMap(() => {
        const choices = structuredClone(question.choices);
        question.choices = [];
        return FlatFacades.ChoiceEntityFacade.copyChoices(store, choices, question, true)
      }),
      mergeMap(() =>
        store.dispatch(new FlatActions.QuestionEntityActions.AddEntity(question))
      ),
      mergeMap((data) => {
        if (clusterParentUpdate) {
          return of(data);
        }
        return store.dispatch(new FlatActions.PageEntityActions.UpdateEntity(page));
      }),
      mergeMap(() => of(question.id))
    )
  }
  
  static copyQuestions(store: Store,
                       ids: string[],
                       page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training,
                       clusterParentUpdate = false) {
    if (ids.length === 0) {
      return of([]);
    }
    
    // Sort Questions
    const typedQuestions = store.selectSnapshot(FlatStates.QuestionEntityState.typedEntities$)
    const sortedIds = ids.reduce((arr, id) => {
      const entity = typedQuestions[id];
      if (entity) {
        arr.push(entity);
      }
      return arr;
    }, [] as FlatModels.QuestionEntityModels.QuestionEntityType[])
    .sort((a, b) => a.order - b.order)
    .map((group) => group.id);
    
    // Copy Questions
    return forkJoin(sortedIds.map(id => QuestionEntityFacade.copyQuestion(store, id, page, true))).pipe(
      mergeMap((newIds) => {
        const selectIds = newIds.reduce((arr, id) => {
          if (id !== undefined) {
            arr.push(id);
          }
          return arr;
        }, [] as string[]);
        return of(selectIds);
      }),
      mergeMap((selectIds) => {
        if (clusterParentUpdate) {
          return of(selectIds);
        }
        return store.dispatch(new FlatActions.PageEntityActions.UpdateEntity(page)).pipe(
          mergeMap(() => of(selectIds))
        );
      }),
    )
  }

  static removeQuestion(store: Store,
                        id: string,
                        clusterParentUpdate = false) {
    // Get Data
    const typedPages = store.selectSnapshot(FlatStates.PageEntityState.typedEntities$);
    const typedQuestions = store.selectSnapshot(FlatStates.QuestionEntityState.typedEntities$);
    const typedChoices = store.selectSnapshot(FlatStates.ChoiceEntityState.typedEntities$);

    // Get Question
    const question = structuredClone(typedQuestions[id]);

    // Get Page
    const page = structuredClone(typedPages[question.slide]) as FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training;
    page.questions.splice(page.questions.findIndex(id => id === question.id), 1);
    
    // Get Choices
    const choices = (question.choices).reduce((arr, choice) => {
      const entity = structuredClone(typedChoices[choice]);
      if (entity) {
        arr.push(entity);
      }
      return arr;
    }, [] as FlatModels.ChoiceEntityModels.Choice[]);

    // Remove Question
    return store.dispatch(new FlatActions.BulkEditAuthorActions.RemoveQuestion(id)).pipe(
      mergeMap((result) => {
        if (choices.length > 0) {
          return forkJoin(choices.map(choice => store.dispatch(new FlatActions.ChoiceEntityActions.RemoveEntity(choice))))
        }
        return of(result);
      }),
      mergeMap(() =>
        store.dispatch(new FlatActions.QuestionEntityActions.RemoveEntity(question))
      ),
      mergeMap((data) => {
        if (clusterParentUpdate) {
          return of({data, page});
        }
        return store.dispatch(new FlatActions.QuestionEntityActions.RearrangeQuestions(page.questions)).pipe(
          mergeMap(() =>
            store.dispatch(new FlatActions.PageEntityActions.UpdateEntity(page))
          )
        );
      }),
    );
  }

  static removeQuestions(store: Store,
                         ids: string[]) {
    if (ids.length === 0) {
      return of([]);
    }

    // Remove Questions
    return of({}).pipe(
      mergeMap(() =>
        forkJoin(ids.map(id => QuestionEntityFacade.removeQuestion(store, id, true)))
      ),
      mergeMap((data: {data: Store, page: FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training}[]) => {
        const pageMap = data.reduce((arr, clusterParentUpdate) => {
          const page = structuredClone(arr.get(clusterParentUpdate.page.id));
          if (page) {
            page.questions = clusterParentUpdate.page.questions.filter((id: string) => page.questions.includes(id));
            arr.set(clusterParentUpdate.page.id, page);
          } else {
            arr.set(clusterParentUpdate.page.id, clusterParentUpdate.page);
          }
          return arr;
        }, new Map<string, FlatModels.PageEntityModels.Slide | FlatModels.PageEntityModels.Training>());
        const pages = Array.from(pageMap.values());
        if (pages.length > 0) {
          return forkJoin(pages.map((page) =>
            store.dispatch(new FlatActions.QuestionEntityActions.RearrangeQuestions(page.questions)).pipe(
              mergeMap(() =>
                store.dispatch(new FlatActions.PageEntityActions.UpdateEntity(page))
              )
            )
          ))
        }
        return of(pages);
      }),
    );
  }

  //</editor-fold>
}
